import { ASSETS_LAYER, ASSETS_SOURCE } from '@/components/composite/GeoMap/drawers/AssetsMapDrawer/AssetsMapDrawer.constants';

export const SOURCE = {
  ...ASSETS_SOURCE,
  /** @deprecated */
  INCIDENTS: 'incidents-source',
  INCIDENT_CLUSTERS: 'incidents-source-clusters',
  DEMO_LOCATIONS: 'demo-locations',
};

export const LAYER = {
  ...ASSETS_LAYER,
  INCIDENTS: 'incidents-layer',
  INCIDENT_CLUSTERS: 'incidents-layer-clusters',
  INCIDENTS_ACTIVE: 'incidents-active-layer',
  DEMO_LOCATIONS: 'demo-locations',
};

export { TextColor } from '@/components/composite/GeoMap/drawers/AssetsMapDrawer/AssetsMapDrawer.constants';

export const PointColor = {
  Red: '#EC281C',
  Violet: '#8465DE',
  Yellow: '#FFD439',
};
